import { Injectable } from "@angular/core";
import { ApiService, UtilService } from "src/app/shared/services";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root'
})
export class HealthFirstService {
  constructor(
    private api: ApiService,
    private util: UtilService
  ) {}

  ngOnInit() {
    this.getEntityId();
  }

  public selectedBenefit: any = null;
  public calculatorData: any;
  entityId;
  
  getEntityId() {
    const data = this.util.getUserData();
    this.entityId = data.id;
  }
  
  getHealthFirstData() {
    let url = environment.APP.API_URLS.GET_HEALTH_FIRST_PLANS();
    if (this.util.isMobile()) {
      url += '?type=mobile';
    }
    return this.api.get(url);
  }

  checkUserExists(payload) {
    const url = environment.APP.API_URLS.REGISTER;
    return this.api.get(url, payload);
  }

  sendLeadData(payload) {
    this.getEntityId();
    const url = environment.APP.API_URLS.PUT_HF_SEND_LEADS_INFOS(this.entityId)
    return this.api.put(url, payload);
  }

  postHfCalculatorData(payload) {
    const url = environment.APP.API_URLS.POST_HEALTH_FIRST_CALCULATOR();
    return this.api.post(url, payload);
  }

  getHFPolicyDetails() {
    this.getEntityId();
    const url = environment.APP.API_URLS.GET_HF_POLICY_DETAILS(this.entityId);
    return this.api.get(url);
  }
}